import { render, staticRenderFns } from "./New-Ai-Request-Step2.vue?vue&type=template&id=f2da764e&scoped=true&"
import script from "./New-Ai-Request-Step2.vue?vue&type=script&lang=js&"
export * from "./New-Ai-Request-Step2.vue?vue&type=script&lang=js&"
import style0 from "./New-Ai-Request-Step2.vue?vue&type=style&index=0&id=f2da764e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2da764e",
  null
  
)

export default component.exports